import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';

import {EquipmentTypeDropdownComponent} from '../../components/DomainData/EquipmentTypeDropdown.component';
import {ModelGroupDropdownComponent} from '../../components/DomainData/ModelGroupDropdown.component';
import {SpecificModelReasonDropdownComponent} from '../../components/DomainData/SpecificModelReasonDropdown.component';
import {ModelDropdownComponent} from '../../components/DomainData/ModelDropdown.component';
import {EquipmentGraphicsDropdownComponent} from '../../components/DomainData/EquipmentGraphicsDropdown.component';
import {CoolerDoorDropdownComponent} from '../../components/DomainData/CoolerDoorDropdown.component';
import {CoolerStyleDropdownComponent} from '../../components/DomainData/CoolerStyleDropdown.component';

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';
import { Model } from '../../entities/Model';
import { CoolerStyle } from '../../entities/index';

@Component({
  selector: 'my-coolerlineitem-edit',
  templateUrl: './CoolerLineItemEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => CoolerLineItemEditComponent)}]
})
export class CoolerLineItemEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    coolerLineItemForm: FormGroup;

    
    @Input() public lineItem: ent.CoolerLineItem;
    model: Model;

    @Input() public requireEquipmentType: boolean;
    @Input() public requireModelGroup: boolean;
    @Input() public requireSpecificModelReason: boolean;
    @Input() public requireModel: boolean;
    @Input() public requireEquipmentGraphics: boolean;
    @Input() public requireEquipmentLocation: boolean;
    @Input() public requireNumberOfCoolers: boolean;

    @ViewChild(EquipmentTypeDropdownComponent) public equipmentTypeDropdown: EquipmentTypeDropdownComponent;
    @ViewChild(ModelGroupDropdownComponent) public modelGroupDropdown: ModelGroupDropdownComponent;
    @ViewChild(SpecificModelReasonDropdownComponent) public specificModelReasonDropdown: SpecificModelReasonDropdownComponent;
    @ViewChild(ModelDropdownComponent) public modelDropdown: ModelDropdownComponent;
    @ViewChild(EquipmentGraphicsDropdownComponent) public equipmentGraphicsDropdown: EquipmentGraphicsDropdownComponent;
    @ViewChild(CoolerDoorDropdownComponent) public coolerDoorDropdownComponent: CoolerDoorDropdownComponent;
    @ViewChild(CoolerStyleDropdownComponent) public coolerStyleDropdownComponent: CoolerStyleDropdownComponent;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
          'equipmentType' : '',
          'modelGroup' : '',
          'specificModelNeeded' : '',
          'specificModelReason' : '',
          'model' : '',
          'includeTopper' : '',
          'equipmentGraphics' : '',
          'equipmentLocation' : '',
          'numberOfCoolers' : '',
          'defaultModel' : {value:'', disabled: "true"},
          'materialNumber' : {value:'', disabled: "true"},
          'conaModelGroup' : {value:'', disabled: "true"},
          'coolerDoor' : '',
          'coolerStyle' : '',
        };
        
        this.coolerLineItemForm = fb.group(group);
        

    }


    ngOnInit(): void {



        if(this.requireEquipmentType) {
            this.coolerLineItemForm.controls['equipmentType'].setValidators(Validators.required);
        }

        if(this.requireModelGroup) {
            this.coolerLineItemForm.controls['modelGroup'].setValidators(Validators.required);
        }

        if(this.requireSpecificModelReason) {
            this.coolerLineItemForm.controls['specificModelReason'].setValidators(Validators.required);
        }

        if(this.requireModel) {
            this.coolerLineItemForm.controls['model'].setValidators(Validators.required);
        }

        if(this.requireEquipmentGraphics) {
            this.coolerLineItemForm.controls['equipmentGraphics'].setValidators(Validators.required);
        }

        if(this.requireEquipmentLocation) {
            this.coolerLineItemForm.controls['equipmentLocation'].setValidators(Validators.required);
        }

        if(this.requireNumberOfCoolers) {
            this.coolerLineItemForm.controls['numberOfCoolers'].setValidators(Validators.required);
        }
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.setMaterialNumber();
        this.onOK.emit();
        
        this.displayDialog = false;

    }

    equipmentTypeChange(event: any){
        if (event){
            this.lineItem.EquipmentTypeID = event;
            this.modelGroupDropdown.filter.EquipmentTypeID = event;
            this.modelGroupDropdown.loadOnDemand();
            this.equipmentGraphicsDropdown.loadOnDemand();
        }

    }

    modelGroupChange(event: any){
        
        this.lineItem.ModelGroupID = event;
        if (event){
            this.modelDropdown.filter.ModelGroupID = event;
            this.modelDropdown.loadOnDemand();
            this.setDefaultModel();
        }
    }

    specificModelReasonChange(event: any){
        this.lineItem.SpecificModelReasonID = event;
    }

    modelChange(event: any){
        this.lineItem.ModelID = event;

        this.model = this.modelDropdown.models.filter(x=>x.ID == this.lineItem.ModelID)[0];
        this.equipmentGraphicsDropdown.filter.EquipmentGraphicsIDs = [];
        if (this.model){
            if (this.model.AllowTopper){
                if (this.lineItem.IncludeTopper === undefined){
                    this.lineItem.IncludeTopper = true;
                }
            }
            else{
                this.lineItem.IncludeTopper = false;
            }
            if (this.model.EquipmentGraphics){
                for (var eg of this.model.EquipmentGraphics){
                    this.equipmentGraphicsDropdown.filter.EquipmentGraphicsIDs.push(eg.ID);
                }
            }
            if (this.model.RequireCoolerDoor){
                this.coolerLineItemForm.controls['coolerDoor'].setValidators(dropDownValidator);
            }
            else{
                this.coolerLineItemForm.controls.coolerDoor.clearValidators();
            }
            this.coolerLineItemForm.controls.coolerDoor.updateValueAndValidity()
        }
        this.equipmentGraphicsDropdown.loadOnDemand();

        this.setMaterialNumber();
        this.setCONAModelNumber();
    }

    equipmentGraphicsChange(event: any){
        this.lineItem.EquipmentGraphicsID = event;
    }

    specificModelNeededChange(event: any){
        this.lineItem.ModelGroupID = this.modelGroupDropdown.value;
        this.setDefaultModel();
    }

    coolerDoorChange(event: any){
        this.lineItem.CoolerDoorID = event;
    }

    coolerStyleChange(event: any){
        this.lineItem.CoolerStyleID = event;
    }

    setDefaultModel(){
        this.lineItem.DefaultModel = "";
        if (!this.lineItem.SpecificModelNeeded){
            if (this.lineItem.ModelGroupID > 0){
                var modelGroups = this.modelGroupDropdown.modelGroups.filter(x=>x.ID == this.lineItem.ModelGroupID);
                if (modelGroups.length > 0){
                    this.lineItem.DefaultModel = modelGroups[0].Name;
                }

                
            }
        }
    }

    setMaterialNumber(){
        this.lineItem.MaterialNumber = "";
        if (this.lineItem.ModelID > 0){
            var models = this.modelDropdown.models.filter(x=>x.ID == this.lineItem.ModelID);
            if (models.length > 0){
                this.lineItem.MaterialNumber = models[0].MaterialNumber;
            }
            
        }
    }

    setCONAModelNumber(){
        this.lineItem.CONAModelGroup = "";
        if (this.lineItem.ModelGroupID > 0){
            var models = this.modelDropdown.models.filter(x=>x.ID == this.lineItem.ModelID);
            if (models.length > 0){
                this.lineItem.CONAModelGroup = models[0].CONAModelGroup;
            }
            
        }
    }

}